import { Link } from 'react-router-dom';
import { AuthShell as DreamtreeAuthShell, getBrand } from '@dreamtree-org/landing-kit/auth';
import '@dreamtree-org/landing-kit/auth.css';

const brand = getBrand('aiagentbuilder');

/**
 * The shared frame for every sign-in screen (single-tenant login, company login, reset,
 * invitation, platform console) — the Dreamtree-wide auth layout from
 * @dreamtree-org/landing-kit/auth, in AI Agent Builder's brand. No logoSrc: client/public only
 * has the legacy blue "G" PWA icon, so the shell's monogram tile is used instead.
 * `login-page` keeps the audited 44px password-toggle hit area (index.css).
 */
export default function AuthShell({ variant, className = '', ...props }) {
  return (
    <DreamtreeAuthShell
      brand={brand}
      variant={variant}
      linkComponent={Link}
      className={`login-page ${className}`.trim()}
      {...props}
    />
  );
}
